import type React from 'react';

/**
 * Hover handlers for a quest preview card, for a mouse only: a tap opens the quest itself, and the
 * mouse events it emulates would leave a card sitting over the page it just opened.
 */
export function previewHover(show: (pos: { x: number; y: number }) => void, hide: () => void) {
  const follow = (event: React.PointerEvent) => {
    if (event.pointerType !== 'touch') show({ x: event.clientX, y: event.clientY });
  };
  return { onPointerEnter: follow, onPointerMove: follow, onPointerLeave: hide };
}
